import React, { createContext} from "react";

  const AddWishListContext = createContext();
  export default AddWishListContext;